module.exports = require('./dist/lib/runtime-config')



//////////////////
// WEBPACK FOOTER
// ../node_modules/next/config.js
// module id = 58
// module chunks = 68